export default "__VITE_ASSET__QanuAjfm__"